/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputReal } from "../../d-dialog-input-real";
import { DThemeWhiteDialogInput } from "./d-theme-white-dialog-input";

export class DThemeWhiteDialogInputReal
	extends DThemeWhiteDialogInput
	implements DThemeDialogInputReal {}
